import React, { useEffect, useState } from 'react';
import { Feature } from '@loyalty/shared-common';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IncomingIngestorWebhookAttributes } from '@loyalty/shared-common/ingestor-api-client';
import {
  QlfFilterDetails,
  QlfMasterDetail,
  QlfSimpleDetail,
} from '@qualifio/ui-commons/dist/components/qlf-master-detail';
import { QlfPlaceholder } from '@qualifio/ui-commons';
import { Skeleton } from '@mui/material';
import { faTrash } from '@fortawesome/pro-solid-svg-icons/faTrash';
import { useTranslation } from 'react-i18next';
import { IncomingWebhookDetails } from '../../libs/program-incoming-webhooks/components/detail/IncomingWebhookDetails';
import {
  IncomingWebhooksProvider,
  useIncomingWebhooks,
} from '../../libs/program-incoming-webhooks/IncomingWebhookContext';
import { QlfMasterDetailContainer } from '../../libs/shared/layout/QlfMasterDetailContainer';
import { useFeatures } from '../../libs/features/FeaturesContext';

function IncomingWebhooks() {
  const { t } = useTranslation();
  const [searchField, setSearchField] = useState('');
  const {
    error,
    webhooks,
    selectedWebhook,
    createWebhook,
    deleteWebhook,
    setSelectedWebhook,
    getWebhooks,
    isLoading,
  } = useIncomingWebhooks();
  const { features } = useFeatures();
  const { write: incomingWebhookWrite, remove: incomingWebhookRemove } =
    features[Feature.INCOMING_WEBHOOK];

  const templateHeader = () => (
    <QlfFilterDetails
      placeholder={t('incoming-webhook.sidebar.search')}
      onAdd={createWebhook}
      disableAdd={!incomingWebhookWrite}
      onAddTooltip={incomingWebhookWrite ? '' : t('shared.action.permission.required')}
      onChange={e => setSearchField(e.target.value)}
    />
  );

  const templateRow = (props: { data: IncomingIngestorWebhookAttributes }) => {
    const { data: webhook } = props;

    const options = [
      {
        node: <p>{t('generic.actions.hard-delete')}</p>,
        startIcon: <FontAwesomeIcon fixedWidth={true} icon={faTrash} />,
        callback: () => deleteWebhook(webhook.id),
        disabled: !incomingWebhookRemove,
        tooltip: incomingWebhookRemove ? '' : t('shared.action.permission.required'),
      },
    ];

    return (
      <QlfSimpleDetail
        state={webhook.id === selectedWebhook?.id ? 'active' : 'default'}
        options={options}
        callback={() => setSelectedWebhook(props.data)}
        content={webhook.name}
      />
    );
  };

  const items = webhooks.filter(
    incomingWebhook => !searchField || incomingWebhook.name.includes(searchField),
  );

  useEffect(() => {
    if (!webhooks) {
      getWebhooks();
    }
  }, []);

  return (
    <QlfMasterDetailContainer>
      {isLoading(getWebhooks) ? (
        <Skeleton />
      ) : error ? (
        <QlfPlaceholder primaryText={t('incoming-webhooks.errors.loading')} />
      ) : (
        <QlfMasterDetail
          templateHeader={templateHeader}
          templateRow={templateRow}
          templateDetail={IncomingWebhookDetails}
          items={items}
        />
      )}
    </QlfMasterDetailContainer>
  );
}

export function IncomingWebhooksIndexPage() {
  return (
    <IncomingWebhooksProvider>
      <IncomingWebhooks />
    </IncomingWebhooksProvider>
  );
}
